export const semanticConventions = {
    operationType: "frontend.operation.type",
    componentName: "frontend.component.name",
    // No need to prefix with "frontend." because this is fairly unambiguous
    pageId: "page.id",
    pageInstanceId: "page.instance.id",
    pageRouteTemplate: "page.route.template",
    pageOwner: "page.owner",
    getPageRouteParamAttributeName: (paramName: string) => `page.route.param.${paramName}`,
} as const;
